// src/Check.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Check_default = createIcon({
  displayName: "Check",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.5829 7.3737C19.0274 6.84601 18.1521 6.85925 17.6128 7.40349L10.8079 14.2719L7.41722 10.7574C6.88391 10.2046 6.00481 10.1846 5.44697 10.7126C4.87509 11.254 4.8619 12.1602 5.41779 12.718L9.75115 17.0658C10.3351 17.6517 11.2832 17.6542 11.8703 17.0715L19.605 9.39375C20.1683 8.83454 20.1583 7.92043 19.5829 7.3737Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  Check_default
};
